//#region src/schema/localization/locales/ru.ts
var e = {
	schema: {
		noAllowedValues: "Ни одно значение не удовлетворяет этому ограничению enum.",
		example: "Пример",
		examples: "Примеры",
		default: "Значение по умолчанию",
		schema: "Схема",
		emptyObject: "Пустой объект",
		showAdditionalProperties: "Показать дополнительные свойства",
		showOneMoreProperty: "Показать ещё 1 свойство",
		showMoreProperties: "Показать ещё свойства: {count}",
		forName: "для {name}",
		showSchemaDetails: "Показать детали схемы",
		oneOf: "Один из",
		anyOf: "Любой из",
		allOf: "Все из",
		not: "Не",
		unknownType: "неизвестный тип",
		propertyCount: "Свойства: {count}",
		headerCount: "Заголовки: {count}",
		recursiveReference: "Рекурсивная ссылка на {name}",
		recursive: "рекурсивно",
		additionalProperties: "дополнительные свойства",
		const: "константа",
		deprecated: "устарело",
		discriminator: "Дискриминатор",
		enum: "enum",
		format: "Формат",
		greaterThan: "больше чем",
		keys: "ключи",
		lessThan: "меньше чем",
		max: "макс.",
		min: "мин.",
		maxLength: "макс. длина",
		minLength: "мин. длина",
		multipleOf: "кратно",
		nullable: "может быть null",
		propertyNames: "имена свойств",
		pattern: "Шаблон",
		copyPattern: "Скопировать шаблон",
		readOnly: "только чтение",
		required: "обязательно",
		hideValues: "Скрыть значения",
		showAllValues: "Показать все значения",
		type: "Тип",
		unique: "уникально",
		values: "значения",
		writeOnly: "только запись"
	},
	common: {
		copyDefault: "Скопировать значение по умолчанию",
		copyExample: "Скопировать пример значения"
	},
	actions: { copyLinkTo: "Скопировать ссылку на {name}" }
};
//#endregion
export { e as ru };

//# sourceMappingURL=ru.js.map